import type { FormUnit } from "@suse-o11y/signal/form";
import React from "react";

import { Editor } from "~/components/code/editor";
import { FormFieldReset } from "~/components/form/reset";

import { Widget, WidgetBody, WidgetHeader } from "../../_widget";

import { SettingsSectionFormField } from "./_field";

export interface MarkdownSettingsProps {
	text: FormUnit<string, null, unknown>;
}

export const MarkdownSettings: React.FC<MarkdownSettingsProps> = ({ text }) => (
	<div className="grid h-full grid-cols-3 gap-4">
		<div className="col-span-3 h-full">
			<Widget className="h-full">
				<WidgetHeader className="uppercase" title="Markdown">
					<FormFieldReset className="ml-auto" state={text} />
				</WidgetHeader>

				<WidgetBody className="h-full">
					<SettingsSectionFormField className="h-full" layout="horizontal" state={text}>
						{(monitor, field) => (
							<Editor
								appearance="code"
								height="100%"
								language="markdown"
								onChange={(newText) => field.setInput(newText)}
								size="lg"
								value={field.getInput(monitor)}
							/>
						)}
					</SettingsSectionFormField>
				</WidgetBody>
			</Widget>
		</div>
	</div>
);
